<template>
  <div id="app">
    <Navbar />
    <main class="">
      <router-view></router-view>
    </main>
    
    <Footer />
  </div>
</template>

<script>
  import Navbar from '@/components/NavBar'
  import Footer from '@/components/Footer'

  export default {
      name: 'GrowthAndRelief',
      components: {
        Navbar,
        Footer
      }
  }
</script>



<style>
    @import url('https://fonts.googleapis.com/css?family=Baloo+2&display=swap');
    @import url('https://fonts.googleapis.com/css?family=Rubik&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;400;600&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@100;300;500;600;700&display=swap');
    /* .logo{
      font-family: 'Raleway', sans-serif;
    } */
    body{
      font-family: 'Raleway', sans-serif!important;
      /* font-family: 'Rubik'!important; */
      max-width: 100vw;
      overflow-x: hidden !important;
      /*overflow-y: hidden !important;*/
    }
    html {
      scroll-behavior: smooth;
    }
</style>
